import React from 'react';

const PlayIcon = () => {
  return (
    <svg width='21' height='24' viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M21 12L0.750001 23.2583L0.750002 0.741669L21 12Z' fill='#2481C4' />
    </svg>
  );
};

export default PlayIcon;
